// extracted by mini-css-extract-plugin
export default {"iframeContain":"styles_iframeContain__glJVV","iframeVideo":"styles_iframeVideo__KY8Tb","iframeButton":"styles_iframeButton__-EzNF","color_dark":"styles_color_dark__JWdo9"};